var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgController(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3404 8V9.26035C17.2353 9.53579 19.8511 10.9839 19.8511 12.3027C19.8511 13.7634 16.6264 15.3952 12 15.3952C7.37362 15.3952 4.14894 13.7676 4.14894 12.3027C4.14894 10.9881 6.76468 9.53997 10.6596 9.26035V8C6.20936 8.29631 3 10.0449 3 12.2986V16.6555C3 19.1345 6.86809 21 12 21C17.1319 21 21 19.1345 21 16.6555V12.2986C21 10.0449 17.7906 8.29213 13.3404 8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.4589C7 14.2016 9.59188 15 12 15C14.4081 15 17 14.2062 17 12.4589C17 11.0356 15.281 10.2464 13.34 10V11.7746C13.34 12.6551 12.7389 13.3713 12 13.3713C11.2611 13.3713 10.66 12.6551 10.66 11.7746V10C8.71899 10.2464 7 11.0356 7 12.4589Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.496 6.48198V11.4264C11.496 11.7438 11.7209 12 11.9995 12C12.2781 12 12.503 11.7438 12.503 11.4264V6.48198C13.3622 6.22577 14 5.33861 14 4.27936C14 3.0098 13.087 1.98114 11.9693 2.00026C10.9522 2.01938 10.0795 2.95626 10.0057 4.11111C9.93181 5.24301 10.5897 6.2143 11.496 6.48198Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgController);
export default __webpack_public_path__ + "static/media/controller.ed7ebe42.svg";
export { ForwardRef as ReactComponent };